export interface DbPrompt {
  title: string;
  text: string;
  created_at: string;
  updated_at: string;
  id: number;
  user_id?: number;
}

export interface PromptInterface {
  id?: number;
  title: string;
  text: string;
  user_id?: number;
}

export class Prompt {
  id?: number;
  title: string;
  text: string;
  user_id?: number;

  constructor(prompt: PromptInterface) {
    this.id = prompt.id;
    this.title = prompt.title;
    this.text = prompt.text;
    this.user_id = prompt.user_id;
  }
}
